exports.paramsSerializer = (params) => {
	let options = '?';
	Object.keys(params).forEach((key) => {
		if (typeof params[key] !== 'object' && (params[key] || params[key] === false || params[key] === 0)) {
			options += `${key}=${params[key]}&`;
		} else if (typeof params[key] === 'object' && params[key] && params[key].length) {
			params[key].forEach((el) => {
				options += `${key}=${el}&`;
			});
		}
	});
	return options ? options.slice(0, -1) : options;
};
